export default {
    parts: [],
    baseStyle: (props) => ({
        /* General styling */
        container: {
            width: { base: '100%' },
            maxWidth: { base: 'container.xxxl' },
            margin: { base: '0 auto' }
        },
        componentWrapper: {
            width: { base: '100%' },
            maxWidth: { base: '926px' },
            margin: { base: '0 auto' }
        },
        highlighted: {
            '& .highlighted': {
                position: 'relative',
                display: 'inline-block',
                paddingTop: { base: '8px', lg: props?.isSafari ? '17px' : '10px' },
                paddingBottom: { base: '12px', lg: props?.isSafari ? '10px' : '17px' },
                marginLeft: '5px',
                lineHeight: 0
            },
            '& .highlighted::after': {
                content: '""',
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: '110%',
                height: '170%',
                border: '2px solid black',
                borderRadius: '50%',
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none'
            },
            '& .highlighted.highlighted-small': {
                marginRight: '8px',
                marginLeft: '8px'
            },
            '& .highlighted.highlighted-small::after': {
                width: '115%',
                height: '110%',
                borderWidth: '1px'
            },
            '& .highlighted.white::after': {
                borderColor: 'white'
            },
        },
        sectionTitle: {
            fontSize: { base: '2xl', lg: '32px' },
            lineHeight: { base: '30px', lg: '34px' },
            textAlign: 'center',
            textTransform: 'uppercase',
            fontWeight: 'bold'
        },
        sectionDescription: {
            fontSize: { base: 'md' },
            lineHeight: { base: '24px' },
            textAlign: 'center',
            maxW: { base: '456px' }
        },
        sectionSubTitle: {
            fontSize: {base: 'xl', lg: '2xl'},
            fontWeight: {base: 'bold'},
            marginBottom: {base: 0},
            marginTop: {base: 2}
        },
        drawerContent: {
            maxWidth: '483px',
            padding: { base: 0 }
        },
        drawerBody: {
            padding: { base: '75px 16px 36px', lg: '96px 32px 32px' }
        },
        drawerWrapper: {
            '& .er-modal-icon': {
                width: { base: '50px' },
                height: { base: '50px' },
                margin: { base: '0 auto' },
                marginBottom: { base: 4 }
            },
            '& .er-modal-title': {
                fontSize: { base: 'xl', lg: '2xl' },
                lineHeight: { lg: '34px' },
                fontWeight: { base: 'bold' },
                textTransform: { base: 'uppercase' },
                textAlign: { base: 'center' },
                paddingBottom: { base: 4, lg: 6 }
            },
            '& .er-modal-subtitle': {
                fontSize: { base: 'sm', lg: 'md' },
                lineHeight: { base: '18px', lg: '24px' },
                paddingBottom: { base: 4, lg: 6 }
            },
            '& .er-modal-subtitle ul': {
                paddingLeft: { base: 6 }
            },
            '& .er-modal-code-title': {
                fontSize: { base: 'md' },
                lineHeight: { lg: '20px' },
                fontWeight: { base: 'bold' },
                textTransform: { base: 'uppercase' },
                textAlign: { base: 'center' },
                marginBottom: { base: 1 }
            },
            '& .er-modal-code': {
                width: { base: 'fit-content' },
                margin: { base: '0 auto' },
                fontSize: { base: 'xl', lg: '2xl' },
                lineHeight: { lg: '30px' },
                fontWeight: { base: 'bold' },
                textTransform: { base: 'uppercase' },
                textAlign: { base: 'center' },
                padding: { base: '16px 24px' },
                border: { base: '1px solid black' },
                marginBottom: { base: 4 }
            },
            '& .er-modal-note': {
                fontSize: { base: 'xs' },
                lineHeight: { base: '15px' },
                color: { base: 'grey.700' }
            }
        },
        erModalIcon: {
            width: { base: '50px' },
            height: { base: '50px' },
            margin: { base: '0 auto' },
            marginBottom: { base: 4 }
        },
        erModalTitle: {
            fontSize: { base: 'xl', lg: '2xl' },
            lineHeight: { lg: '34px' },
            fontWeight: { base: 'bold' },
            textTransform: { base: 'uppercase' },
            textAlign: { base: 'center' },
            paddingBottom: { base: 4, lg: 6 }
        },
        erModalSubtitle: {
            fontSize: { base: 'sm', lg: 'md' },
            lineHeight: { base: '18px', lg: '24px' },
            paddingBottom: { base: 4, lg: 6 }
        },
        erModalNote: {
            fontSize: { base: 'xs' },
            lineHeight: { base: '15px' },
            color: { base: 'grey.700' }
        },
        overlay: {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'black',
            opacity: '0.4',
            zIndex: '1'
        },
        components: {
            /* Banner component styling */
            banner: {
                container: {
                    display: { base: 'flex' },
                    justifyContent: { base: 'center' },
                    backgroundColor: 'brandMagenta',
                    paddingY: { base: '20px', lg: '25px' },
                    paddingX: { base: 4, lg: 0 }
                },
                logo: {
                    width: { base: '140px', lg: '240px' },
                    height: { base: '49px', lg: '69px' }
                },
                heroContainer: {
                    position: 'relative'
                },
                titleWrapper: {
                    display: { base: 'flex' },
                    alignItems: { base: 'center' },
                    justifyContent: { base: 'center' }
                },
                heroContent: {
                    position: 'absolute',
                    top: { lg: '50%' },
                    transform: { lg: 'translateY(-50%)' },
                    bottom: { base: '46px', lg: 'auto' },
                    width: { base: '100%' },
                    zIndex: '2'
                },
                arrowIcon: {
                    width: { base: '13px', lg: '21px' },
                    marginRight: { base: 1 }
                },
                title: {
                    fontSize: { base: 'sm', lg: 'xl' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    textAlign: { base: 'center' },
                    color: 'white',
                    display: { base: 'flex' },
                    alignItems: { base: 'baseline' },
                    justifyContent: { base: 'center' }
                },
                heroLogo: {
                    width: { base: '100%' },
                    maxW: { base: '341px', lg: '563px' },
                    margin: { base: '0 auto' }
                },
                ctaContainer: {
                    display: { base: 'flex' },
                    flexDirection: { base: 'column', lg: 'row' },
                    justifyContent: { base: 'center' },
                    alignItems: { base: 'center' },
                    marginTop: { base: '86px', lg: 4 }
                },
                ctaButton: {
                    width: { base: '100%' },
                    maxW: { base: '343px' },
                    maxH: { base: '48px' },
                    fontSize: { base: 'md' },
                    marginRight: { lg: 6 }
                },
                ctaLink: {
                    fontSize: { base: 'md' },
                    fontWeight: { base: 'medium', lg: 'bold' },
                    lineHeight: { lg: '20px' },
                    textTransform: { base: 'uppercase' },
                    textDecoration: { base: 'underline' },
                    textAlign: { base: 'center' },
                    marginTop: { base: 6, lg: 0 },
                    color: { base: 'white' },
                    _hover: {
                        color: { base: 'white' }
                    },
                    _focus: {
                        color: { base: 'white' }
                    }
                }
            },
            /* Account block component styling */
            accountBlock: {
                container: {
                    marginTop: { base: 6, lg: 16 },
                    paddingX: { base: 4, lg: 0 }
                },
                title: {
                    fontSize: { base: '2xl', lg: '40px' },
                    fontWeight: { base: 'bold' },
                    lineHeight: { base: '30px', lg: '45px' },
                    textTransform: { base: 'uppercase' },
                    textAlign: { base: 'center' }
                },
                anchorsContainer: {
                    justifyContent: { base: 'center' },
                    gap: { base: 1, lg: 4 },
                    marginTop: { base: 4, lg: 6 }
                },
                anchor: {
                    fontSize: { base: 'sm' },
                    fontWeight: { base: 'bold' },
                    lineHeight: { base: '11px', lg: '100%' },
                    textTransform: { base: 'uppercase' },
                    textAlign: { base: 'center' },
                    paddingLeft: { base: 4, lg: 8 },
                    paddingRight: { base: 4, lg: 8 },
                    paddingTop: { base: '12px', lg: '7px' },
                    paddingBottom: { base: '7px', lg: '10px' },
                    minHeight: { base: 'auto' },
                    height: { base: 'auto' }
                },
                loyaltyInfoContainer: {
                    paddingTop: { base: 4 },
                    paddingBottom: { base: 4 },
                    marginTop: { base: 0, lg: 10 },
                    marginBottom: { base: 9, lg: 20 }
                },
                loyaltyHeader: {
                    paddingBottom: { base: 6, lg: 8 },
                    borderBottom: { base: '1px solid' },
                    borderColor: 'black',
                    marginBottom: { base: 6, lg: 8 }
                },
                loyaltyFooter: {
                    display: { lg: 'flex' },
                    alignItems: { lg: 'baseline' },
                    paddingTop: { base: 2, lg: 3 },
                    borderTop: { base: '1px solid' },
                    borderColor: 'black',
                    marginTop: { base: 6, lg: 8 }
                },
                loyaltyPointsBlock: {
                    justifyContent: { base: 'space-between' }
                },
                loyaltyText: {
                    fontSize: { base: 'sm', lg: 'md' },
                    lineHeight: { base: '18px', lg: '24px' },
                    marginBottom: { base: 2, lg: 1 }
                },
                loyaltySubText: {
                    fontSize: { base: 'xs', lg: 'md' },
                    lineHeight: { base: '15px', lg: '24px' },
                    marginBottom: { base: 2, lg: 1 }
                },
                loyaltyTitle: {
                    fontSize: { base: 'xl', lg: '32px' },
                    lineHeight: { base: '20px', lg: '34px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' }
                },
                loyaltyLink: {
                    fontSize: { base: 'sm', lg: 'md' },
                    lineHeight: { base: '18px', lg: '21px' },
                    fontWeight: {base: 'normal'}
                },
                loyaltyFooterText: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' },
                    marginBottom: { base: 1 },
                    paddingRight: { lg: 1 }
                },
                loyaltyFooterSubText: {
                    fontSize: { base: 'xs', lg: 'sm' },
                    lineHeight: { base: '15px', lg: '18px' }
                },
                drawerContent: {
                    maxWidth: '483px'
                },
                drawerCloseIcon: {
                    position: 'absolute',
                    width: { base: '24px' },
                    height: { base: '24px' },
                    top: { base: '24px' },
                    right: { base: '16px' },
                    zIndex: '2',
                    backgroundColor: 'transparent',
                    _hover: {
                        backgroundColor: 'transparent'
                    },
                    color: 'black'
                },
                drawerBody: {
                    padding: { base: '24px 16px 36px', lg: '80px 32px 16px' }
                },
                drawerTitle: {
                    fontSize: { base: '20px', lg: '32px' },
                    lineHeight: { base: '100%', lg: '34px' },
                    fontWeight: { base: 'bold' },
                    textAlign: { base: 'center' },
                    textTransform: { base: 'uppercase' },
                    paddingBottom: { base: 6 }
                },
                drawerPointsTitle: {
                    fontSize: { base: '24px' },
                    lineHeight: { base: '30px' },
                    textTransform: { base: 'uppercase' },
                    fontWeight: { base: 'bold' },
                    marginBottom: { base: 1 }
                },
                drawerResetDate: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' }
                },
                transactionContainer: {
                    marginTop: { base: 8 }
                },
                transactionBlock: {
                    marginBottom: { base: 5 },
                },
                transactionDate: {
                    fontSize: { base: 'xs' },
                    lineHeight: { base: '15px' },
                    marginBottom: { base: 2 },
                    color: 'grey.700'
                },
                transactionCard: {
                    padding: { base: 4 },
                    backgroundColor: { base: 'gray.200' },
                    justifyContent: { base: 'space-between' },
                    alignItems: { base: 'center' }
                },
                transactionInfo: {
                    alignItems: { base: 'center' }
                },
                purchase: {
                    fontSize: { base: 'md' },
                    lineHeight: { base: '16px' },
                    paddingLeft: { base: 1 }
                },
                transactionPoints: {
                    flex: { base: '0 0 auto' }
                },
                infoCircle: {
                    width: '20px',
                    height: '20px',
                    marginLeft: 1,
                    cursor: 'pointer'
                },
                modalContent: {
                    padding: { base: '24px 16px', lg: '24px 32px' },
                    width: { base: '100%' },
                    maxW: { lg: '900px' }
                },
                modalIcon: {
                    background: "transparent",
                    _hover: { background: 'transparent' },
                    display: "block",
                    marginLeft: "auto"
                },
                modalHeader: {
                    padding: 0
                },
                modalBody: {
                    padding: 0
                },
                modalTitle: {
                    fontSize: { base: 'lg', lg: '2xl' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    textAlign: { base: 'center' },
                    marginBottom: { base: 6, lg: 8 }
                },
                modalText: {
                    textAlign: { base: 'center' },
                    marginBottom: { base: 4 }
                }
            },
            /* Loyalty status component styling */
            loyaltyStatus: {
                progressBarContainer: {
                    marginTop: { base: 4, lg: 8 }
                },
                progressBarWrapper: {
                    position: 'relative',
                    height: { base: 4, lg: '18px' },
                    borderRadius: 'full',
                    backgroundColor: '#E2DFDA',
                    overflow: 'hidden',
                    zIndex: '1'
                },
                progressFill: {
                    height: '100%',
                    backgroundColor: 'brandMagenta',
                    borderRadius: 'full',
                    transition: 'width 0.5s ease-in-out',
                },
                labelsRow: {
                    justify: 'space-between',
                    marginTop: { base: 2, lg: 4 },
                },
                labelWrapper: {
                    position: 'relative',
                    textAlign: 'center',
                    flex: 1,
                },
                labelText: {
                    fontSize: { base: 'xs', lg: 'sm' },
                    lineHeight: { base: '15px', lg: '18px' }
                },
                arrow: {
                    position: 'absolute',
                    top: { base: '-13px', lg: '-26px' },
                    width: { base: '10px', lg: '18px' },
                    height: { base: '10px', lg: '18px' },
                    backgroundColor: 'brandMagenta'
                },
                arrowLeft: {
                    left: { base: '9px' },
                    transform: 'translateX(0) rotate(45deg)',
                },
                arrowRight: {
                    right: { base: '9px' },
                    transform: 'translateX(0) rotate(45deg)',
                },
                arrowCenter: {
                    left: '50%',
                    transform: 'translateX(-50%) rotate(45deg)',
                }
            },
            /* Exclusive Rewards component styling */
            exclusiveRewardsBlock: {
                container: {
                    paddingTop: { base: 11, lg: 20 },
                    paddingRight: { base: 11, lg: 0 },
                    paddingBottom: { base: 11, lg: 20 },
                    paddingLeft: { base: 11, lg: 0 }
                },
                tiles: {
                    display: { lg: 'flex' },
                    flexWrap: { lg: 'wrap' },
                    justifyContent: { lg: 'center' },
                    gap: { lg: 2 },
                    marginTop: { lg: '50px' }
                },
                mobileGrid: {
                    display: { base: 'grid', lg: 'flex' },
                    gridTemplateColumns: { base: 'repeat(2, 1fr)' },
                    justifyContent: { lg: 'center' },
                    gap: { base: 2 }
                },
                sectionDescription: {
                    margin: { base: '0 auto' },
                    marginTop: { base: 4 }
                },
                tileWrapper: {
                    display: { lg: 'flex' },
                    alignItems: { lf: 'center' },
                    justifyContent: { lg: 'center' },
                    flex: { lg: '0 0 calc(25% - 6px)' },
                    window: { lg: '100%' },
                    marginTop: { base: '40px', lg: 0 },
                    marginX: { base: 'auto', lg: 0 },
                    paddingX: { lg: 4 },
                    maxW: { base: '185px', lg: '100%' },
                    minHeight: { lg: '194px' },
                    textAlign: { base: 'center' },
                    backgroundColor: { lg: 'white' },
                    '& .er-tile': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        paddingTop: { lg: '40px' }
                    },
                    '& .er-icon': {
                        width: { lg: '24px' },
                        height: { lg: '24px' },
                        marginBottom: { base: 5, lg: '10px' }
                    },
                    '& .er-title': {
                        fontSize: { base: 'md' },
                        lineHeight: { base: '20px' },
                        fontWeight: { base: 'bold' },
                        textTransform: { base: 'uppercase' },
                        textDecoration: { base: 'underline' },
                        marginBottom: { base: 4, lg: '10px' }
                    },
                    '& .er-title.no-decoration': {
                        textDecoration: { base: 'none' },
                    },
                    '& .er-subtitle': {
                        fontSize: { base: 'sm' },
                        lineHeight: { base: '18px' }
                    },
                    '& .er-badge': {
                        fontSize: { base: '10px' },
                        lineHeight: { base: '100%' },
                        padding: {base: '1px 8px 3px'},
                        border: {base: '1px solid'},
                        borderColor: {base: 'color'}
                    }
                },
                gridTileWrapper: {
                    display: { lg: 'flex' },
                    alignItems: { lf: 'center' },
                    justifyContent: { lg: 'center' },
                    flex: { lg: '0 0 calc(25% - 6px)' },
                    window: { lg: '100%' },
                    marginX: { base: 'auto', lg: 0 },
                    minHeight: { lg: '194px' },
                    textAlign: { base: 'center' },
                    backgroundColor: { lg: 'white' },
                    width: { base: '100%' },
                    padding: { base: '24px 10px 20px', lg: '0 20px' },
                },
                erIcon: {
                    width: { base: '24px' },
                    height: { base: '24px' },
                    marginBottom: { base: '10px' }
                },
                erTile: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    paddingTop: { lg: 10 }
                },
                erTitle: {
                    fontSize: { base: 'sm', lg: 'md' },
                    lineHeight: { base: '16px', lg: '20px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    textDecoration: { base: 'underline' },
                    marginBottom: { base: '10px' }
                },
                erSubtitle: {
                    fontSize: { base: 'xs', lg: 'sm' },
                    lineHeight: { base: '15px', base: '18px' }
                },
                erCompleted: {
                    display: { base: 'flex' },
                    justifyContent: { base: 'center' },
                    alignItems: { base: 'center' },
                    fontSize: { base: 'xs' },
                    lineHeight: { base: '15px' },
                    backgroundColor: 'black',
                    color: 'white',
                    minHeight: '25px',
                    minWidth: '90px',
                    marginTop: '10px'
                }
            },
            /* Loyalty program component styling */
            loyaltyProgram: {
                container: {
                    padding: { base: '40px 0 64px' }
                },
                heading: {
                    padding: { base: '24px 16px 40px', lg: 0 },
                    backgroundColor: { base: 'gray.200', lg: 'unset' },
                    marginBottom: { base: 2, lg: 0 }
                },
                levels: {
                    display: { base: 'flex' },
                    gap: { lg: 2 },
                    alignItems: { lg: 'center' },
                    justifyContent: { base: 'center' },
                    marginTop: { base: 8, lg: 12 }
                },
                levelsWrapper: {
                    display: { lg: 'flex' },
                    flex: { lg: '0 0 calc(50% - 4px)' },
                    width: { lg: '100%' },
                    maxW: { lg: '50%' }
                },
                level: {
                    display: { base: 'flex' },
                    flexDirection: { base: 'column' },
                    alignItems: { base: 'center' },
                    justifyContent: { base: 'center' },
                    flex: { base: '0 0 33.333333%' },
                    maxW: { base: '33.333333%' },
                    minHeight: { base: '55px' },
                    width: { base: '100%' }
                },
                levelName: {
                    fontSize: { base: 'md' },
                    lineHeight: { base: '20px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                },
                levelDescription: {
                    fontSize: { base: 'xs' },
                    lineHeight: { base: '15px' }
                },
                accItem: {
                    backgroundColor: { base: 'gray.200', lg: 'unset' },
                    border: { base: 0 },
                    paddingLeft: { base: 4, lg: 0 },
                    paddingRight: { base: 4, lg: 0 },
                    marginBottom: { base: 2, lg: 0 }
                },
                accBtn: {
                    display: { base: 'flex' },
                    justifyContent: { base: 'space-between' },
                    padding: { base: '16px 0' },
                    marginTop: { lg: 12 }
                },
                accPanel: {
                    marginTop: { base: 2, lg: 0 },
                    padding: { base: '0 0 24px', lg: 0 },
                    borderTop: { base: '1px solid', lg: 0 },
                    borderColor: { base: 'black' }
                },
                content: {
                    display: { lg: 'flex' },
                    alignItems: { lg: 'stretch' },
                    gap: { lg: 2 },
                    borderBottom: { lg: '1px solid' },
                    borderColor: { lg: 'black' }
                },
                nameAndDesc: {
                    flex: { lg: '1' },
                    width: { lg: '100%' },
                    maxW: { lg: '50%' },
                    cursor: { lg: 'pointer' }
                },
                accTitle: {
                    fontSize: { base: 'lg' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    flex: { lg: '1' },
                    width: { lg: '100%' },
                    maxW: { lg: '50%' }
                },
                contentName: {
                    display: { lg: 'flex' },
                    alignItems: { lg: 'center' },
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '16px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    marginTop: { base: 6, lg: 0 },
                    padding: { lg: '16px 0' }
                },
                chevronIcon: {
                    marginLeft: { lg: 2 }
                },
                contentDescription: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' },
                    marginTop: { base: 1, lg: 0 },
                    paddingBottom: { lg: 4 }
                },
                cards: {
                    display: { base: 'flex' },
                    flex: { lg: '1' },
                    width: { lg: '100%' },
                    maxW: { lg: '50%' },
                    borderBottom: { base: '1px solid', lg: 0 },
                    borderColor: { base: 'black' }
                },
                card: {
                    display: { base: 'flex' },
                    alignItems: { base: 'center' },
                    justifyContent: { base: 'center' },
                    flex: { base: '0 0 33.333333%' },
                    maxW: { base: '33.333333%' },
                    minHeight: { base: '55px' },
                    width: { base: '100%' },
                    marginTop: { base: 3, lg: 0 }
                },
                cardIcon: {
                    width: '20px',
                    height: '20px',
                    marginRight: 1
                },
                cardText: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' }
                }
            },
            /* Earning points component styling */
            earningPoints: {
                container: {
                    padding: { base: '32px 16px', lg: '40px 0' },
                    backgroundColor: { base: '#FEFCFA' }
                },
                title: {
                    marginBottom: { base: 2 }
                }
            },
            /* Faq component styling */
            faq: {
                container: {
                    paddingY: { base: 8 },
                    paddingX: { base: 4, lg: 0 }
                },
                title: {
                    fontSize: { base: 'sm', lg: 'md' },
                    lineHeight: { base: '18px', lg: '24px' },
                    marginBottom: { base: 1 },
                    textAlign: 'center'
                },
                acc: {
                    marginTop: { base: 6 }
                },
                accItem: {
                    borderColor: 'black'
                },
                accBtn: {
                    fontSize: { base: 'sm', lg: 'md' },
                    lineHeight: { base: '16px', lg: '20px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    display: { base: 'flex' },
                    justifyContent: { base: 'space-between' },
                    textAlign: { base: 'left' },
                    padding: { base: '20px 0', lg: '18px 0' },
                },
                accPanel: {
                    padding: { base: '0 40px 16px 0' },
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' },
                    letterSpacing: { base: 0 }
                },
                footerCopy: {
                    width: '100%',
                    display: { base: 'inline-block' },
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '20px' },
                    marginTop: { base: 6 },
                    textAlign: { base: 'center' },
                    paddingLeft: { lg: 6 },
                    paddingRight: { lg: 6 }
                },
                footerCopyWrapper: {
                    width: '100%',
                    textAlign: 'center',
                    marginTop: 6
                }
            },
            /* How it works component styling */
            howItWorks: {
                container: {
                    paddingTop: { base: '40px', lg: '64px' }
                },
                tilesContainer: {
                    padding: { base: '0 16px', lg: 0 }
                },
                subTilesContainer: {
                    padding: { base: '32px 16px', base: '52px 0' },
                    backgroundColor: { base: 'charcoal' }
                },
                contentWrapper: {
                    display: {lg: 'flex'}
                },
                tiles: {
                    display: 'flex',
                    flexDirection: { base: 'column', lg: 'row' },
                    flexWrap: { lg: 'wrap' },
                    justifyContent: { base: 'center', lg: 'space-between' },
                    alignItems: { base: 'center' },
                    gap: { base: 8, lg: 0 },
                    paddingTop: { base: 8, lg: 0 },
                    paddingBottom: { base: 16 },
                    textAlign: { base: 'center' }
                },
                tile: {
                    display: 'flex',
                    flexDirection: { base: 'column' },
                    justifyContent: { base: 'center' },
                    alignItems: { base: 'center' },
                    maxW: { base: '270px', lg: 'auto' },
                    flex: { lg: '0 0 260px' },
                    marginTop: { lg: 9 }
                },
                tileIcon: {
                    marginBottom: { base: 5 }
                },
                tileTitle: {
                    fontSize: { base: 'md' },
                    lineHeight: { base: '20px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    marginBottom: { base: 2 }
                },
                tileSubtitle: {
                    fontSize: { base: 'sm' },
                    lineHeight: { base: '18px' },
                },
                subTiles: {
                    display: 'flex',
                    flexDirection: { base: 'column', lg: 'row' },
                    justifyContent: { base: 'center', lg: 'space-between' },
                    alignItems: { base: 'center' },
                    color: 'white',
                    textAlign: { base: 'center' }
                },
                subTile: {
                    flex: { lg: '0 0 356px' }
                },
                divider: {
                    maxW: { base: '194px' },
                    marginTop: { base: 6, lg: 0 },
                    marginBottom: { base: 6, lg: 0 },
                    flex: { lg: '0 0 1px' },
                    height: { lg: 'fill-available' },
                    ...(props?.isSafari && {
                        maxH: {lg: '80px'}
                    })
                },
                subTileIcon: {
                    width: { base: '24px', lg: '30px' },
                    height: { base: '24px', lg: '30px' },
                    marginRight: { base: 1, lg: 4 }
                },
                subTileTitle: {
                    display: 'flex',
                    justifyContent: { base: 'center' },
                    alignItems: { base: 'center' },
                    fontSize: { base: 'xl', lg: '32px' },
                    lineHeight: { base: '30px', lg: '34px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    marginBottom: { base: 4 },
                },
                subTileSubtitle: {
                    fontSize: { base: 'lg', lg: 'xl' }
                }
            },
            /* Tiles and app components styling */
            tilesAndApp: {
                container: {
                    display: { base: 'flex' },
                    flexDirection: { base: 'column' },
                    padding: { base: '0 32px', lg: 0 }
                },
                downloadAppContainer: {
                    marginBottom: { base: 4, lg: 10 },
                    order: { lg: 1 },
                    backgroundColor: { lg: 'loyaltyPink' }
                },
                tilesContainer: {
                    display: { base: 'grid' },
                    gridTemplateColumns: { base: '1fr', lg: 'repeat(2, 1fr)' },
                    gap: { base: 4, lg: '10px' },
                    paddingTop: { lg: 10 },
                    paddingBottom: { lg: 10 },
                    order: { lg: 0 }
                },
                dAppWrapper: {
                    display: { lg: 'flex' },
                    gap: { lg: '130px' },
                    alignItems: { lg: 'center' },
                    position: { base: 'relative' },
                    padding: { lg: '50px 0' }
                },
                dAppContent: {
                    position: { base: 'absolute' },
                    width: { base: '100%' },
                    bottom: { base: 8 },
                    display: { base: 'flex' },
                    flexDirection: { base: 'column' },
                    alignItems: { base: 'center' },
                    color: { base: 'white' },
                    zIndex: '1'
                },
                dAppTitle: {
                    display: { base: 'flex', lg: 'block' },
                    alignItems: { base: 'baseline' },
                    textAlign: { base: 'center', lg: 'left' },
                    fontSize: { base: '2xl', lg: '32px' },
                    lineHeight: { base: '30px', lg: '34px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    maxW: { base: '230px', lg: 'unset' }
                },
                dAppSubTitle: {
                    fontSize: { base: 'xl' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    marginTop: { base: 2 }
                },
                dAppIcon: {
                    width: { base: '21px' },
                    height: { base: '21px' }
                },
                dAppLogos: {
                    display: { base: 'flex', lg: 'grid' },
                    flex: { lg: '0 0 auto' },
                    gridTemplateColumns: { lg: 'repeat(2, 1fr)' },
                    gap: { base: 2, lg: 10 },
                    marginTop: { base: 11, lg: 0 }
                },
                dAppLogoQr: {
                    display: { lg: 'flex' },
                    flexDirection: { lg: 'column' },
                    maxW: { lg: '108px' },
                    gap: { lg: 3 }
                },
                tileWrapper: {
                    position: { base: 'relative' }
                },
                tileContent: {
                    position: { base: 'absolute' },
                    width: { base: '100%' },
                    top: { base: '50%' },
                    transform: { base: 'translateY(-50%)' },
                    color: { base: 'white' },
                    zIndex: '1',
                    padding: { lg: 1 }
                },
                tileTitle: {
                    display: { base: 'flex' },
                    alignItems: { base: 'start' },
                    justifyContent: { base: 'center' },
                    textAlign: { base: 'center' },
                    fontSize: { base: '2xl', lg: '32px' },
                    lineHeight: { base: '30px', lg: '34px' },
                    fontWeight: { base: 'bold' },
                    textTransform: { base: 'uppercase' },
                    maxW: { base: '185px', lg: 'unset' },
                    margin: { base: '0 auto' },
                    cursor: 'pointer'
                },
                tileIcon: {
                    width: { base: '21px', lg: '40px' },
                    height: { base: '32px', lg: '40px' },
                    marginRight: { base: 2, lg: 4 }
                }
            }
        }
    })
}
